import React from 'react';
import { BookOpen, Calendar, CheckSquare, PenTool, Activity, ShoppingCart } from 'lucide-react';
export function WhatYouGetSection() {
  const items = [{
    icon: BookOpen,
    title: 'La Guía Completa en PDF',
    desc: '7 capítulos detallados con toda la teoría y práctica.'
  }, {
    icon: Calendar,
    title: 'Plan Diario de 7 Días',
    desc: 'Instrucciones paso a paso para eliminar sofocos nocturnos.'
  }, {
    icon: CheckSquare,
    title: 'Checklists Imprimibles',
    desc: 'Cocina Anti-Sofoco, Respiración Maestra y Rutina Escudo Frío.'
  }, {
    icon: PenTool,
    title: 'Worksheets Personalizables',
    desc: 'Identifica tus triggers personales y crea tu plan nocturno.'
  }, {
    icon: Activity,
    title: 'Diario de Seguimiento',
    desc: '7 días para medir tu progreso y ajustar tu rutina.'
  }, {
    icon: ShoppingCart,
    title: 'Bonus Exclusivos',
    desc: 'Lista de Compras Anti-Trigger y 3 Recetas Frías Latinas.'
  }];
  return <section className="py-20 bg-white" data-id="element-123">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl" data-id="element-124">
        <div className="text-center mb-16" data-id="element-125">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-6" data-id="element-126">
            Todo lo que incluye tu compra hoy
          </h2>
          <p className="text-lg text-slate-600" data-id="element-127">
            Herramientas prácticas para recuperar tu sueño desde la primera
            noche.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-128">
          {items.map((item, index) => <div key={index} className="flex flex-col items-center text-center p-6 rounded-xl bg-slate-50 border border-slate-100 hover:shadow-md transition-shadow" data-id="element-129">
              <div className="w-16 h-16 bg-white rounded-full shadow-sm flex items-center justify-center mb-4 border border-slate-100" data-id="element-130">
                <item.icon className="w-8 h-8 text-teal-600" data-id="element-131" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-132">
                {item.title}
              </h3>
              <p className="text-slate-600" data-id="element-133">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}